/**
 * ROWIE — PDP info lines
 *
 * Multiple independent panels, so open state lives on the panel element
 * rather than on <body> as it does for BNPL and the size guide. Panels
 * and overlays are portalled to <body> on init: an ancestor of the
 * product content column establishes a stacking context that would
 * otherwise trap them below the gallery.
 */

(function () {
  const ROOT = '[data-rowie-info-lines]';

  class PdpInfoLines {
    constructor(root) {
      this.root = root;
      this.panels = new Map();
      this.init();
    }

    init() {
      this.root.querySelectorAll('[data-info-line-panel]').forEach((panel) => {
        const id = panel.dataset.infoLinePanel;
        const overlay = this.root.querySelector(`[data-info-line-overlay="${id}"]`);
        const trigger = this.root.querySelector(`[data-info-line-open="${id}"]`);
        const closeBtn = panel.querySelector(`[data-info-line-close="${id}"]`);

        if (!trigger) return;

        if (overlay && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }
        if (panel.parentElement !== document.body) {
          document.body.appendChild(panel);
        }

        this.panels.set(id, { panel, overlay, trigger, closeBtn });

        trigger.addEventListener('click', () => this.toggle(id));
        if (closeBtn) closeBtn.addEventListener('click', () => this.close(id));
        if (overlay) overlay.addEventListener('click', () => this.close(id));
      });

      document.addEventListener('keyup', (e) => {
        if (e.key !== 'Escape') return;
        this.panels.forEach((_, id) => this.close(id));
      });
    }

    toggle(id) {
      const entry = this.panels.get(id);
      if (!entry) return;
      if (entry.panel.classList.contains('is-open')) this.close(id);
      else this.open(id);
    }

    open(id) {
      const entry = this.panels.get(id);
      if (!entry) return;
      entry.panel.classList.add('is-open');
      if (entry.overlay) entry.overlay.classList.add('is-open');
      entry.trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    close(id) {
      const entry = this.panels.get(id);
      if (!entry || !entry.panel.classList.contains('is-open')) return;
      entry.panel.classList.remove('is-open');
      if (entry.overlay) entry.overlay.classList.remove('is-open');
      entry.trigger.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        if (!document.querySelector('.rowie-info-lines__panel.is-open')) {
          document.body.style.overflow = '';
        }
      }, 400);
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      new PdpInfoLines(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(ROOT).forEach((root) => {
      root.removeAttribute('data-initialised');
    });
    initAll();
  });
})();